const nl2br = function nl2br(text: string) {
    return text.split('\r\n').map((item, key) => {
        return (
            <span key={key}>
                {item}
                <br />
            </span>
        )
    })
}
export default nl2br
